__turbopack_context__.v({
  "arrow": "styles-module__CEfRuG__arrow",
  "buttonLogin": "styles-module__CEfRuG__buttonLogin",
  "buttonTranslate": "styles-module__CEfRuG__buttonTranslate",
  "buttons": "styles-module__CEfRuG__buttons",
  "dropdown": "styles-module__CEfRuG__dropdown",
  "dropdownTranslate": "styles-module__CEfRuG__dropdownTranslate",
  "header": "styles-module__CEfRuG__header",
  "headerContainer": "styles-module__CEfRuG__headerContainer",
  "listMenu": "styles-module__CEfRuG__listMenu",
  "logo": "styles-module__CEfRuG__logo",
  "menu": "styles-module__CEfRuG__menu",
  "menuItem": "styles-module__CEfRuG__menuItem",
  "menuItemActive": "styles-module__CEfRuG__menuItemActive",
  "menuItemDropdown": "styles-module__CEfRuG__menuItemDropdown",
  "menuItemDropdownMobile": "styles-module__CEfRuG__menuItemDropdownMobile",
  "sideMenu": "styles-module__CEfRuG__sideMenu",
});
